// Master Reporting Saga
import { call, put, takeEvery, all } from "redux-saga/effects";

import { GET_MASTER_REPORTING_ITEMS } from "./actionType";

import {
  getMasterReportingItemsSuccess,
  getMasterReportingItemsFailure,
} from "./action";

import { getMasterReportingItemsApi } from "../../helpers/fakebackend_helper";

function* getMasterReportingItems() {
  try {
    const response = yield call(getMasterReportingItemsApi);
    yield put(getMasterReportingItemsSuccess(response));
  } catch (error) {
    yield put(getMasterReportingItemsFailure());
  }
}

function* watchMasterReporting() {
  yield takeEvery(GET_MASTER_REPORTING_ITEMS, getMasterReportingItems);
}

export default function* MasterReporting() {
  yield all([watchMasterReporting()]);
}
